import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
// import FLink from '@/components/FLink';
import { Link } from 'umi';

interface FNavTabsProps {
  options: {
    value: string;
    label: string;
    href: string;
  }[];
  activated: string;
  className?: string;
  /** discover：Figma 发现页 Tab（字号 16 / 间距 50） */
  variant?: 'default' | 'discover';
}

function FNavTabs({ options, activated, className, variant = 'default' }: FNavTabsProps) {
  return (
    <div
      className={[
        styles.styles,
        variant === 'discover' ? styles.discoverTabs : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Space size={variant === 'discover' ? 50 : 60}>
        {options.map((o) => {
          return (
            <Link
              key={o.value}
              className={[styles.Link, activated === o.value ? styles.activated : ''].join(' ')}
              to={o.href}
            >
              <span>{o.label}</span>
            </Link>
          );
        })}
      </Space>
    </div>
  );
}

export default FNavTabs;
